import { AnimatePresence, motion } from 'framer-motion';
import { useCart } from '../shared/context/CartContext';
import './PeacockBurst.css';

const FEATHERS = 11;

export default function PeacockBurst() {
  const { peacockBurst } = useCart();

  return (
    <AnimatePresence>
      {peacockBurst && (
        <motion.div
          className="peacock-burst"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.25 }}
        >
          <div className="peacock-burst__stage" aria-hidden>
            {Array.from({ length: FEATHERS }).map((_, i) => {
              const mid = (FEATHERS - 1) / 2;
              const angle = (i - mid) * 14;
              const delay = 0.03 * Math.abs(i - mid);
              const gid = `pf-${i}`;
              return (
                <motion.span
                  key={i}
                  className="peacock-burst__feather"
                  style={{
                    '--f-angle': `${angle}deg`,
                    transformOrigin: '50% 100%',
                  }}
                  initial={{ opacity: 0, scale: 0.2, rotate: angle * 0.3, y: 18 }}
                  animate={{ opacity: 1, scale: 1, rotate: angle, y: 0 }}
                  exit={{ opacity: 0, scale: 0.6, y: -10 }}
                  transition={{
                    type: 'spring',
                    stiffness: 260,
                    damping: 16,
                    delay,
                  }}
                >
                  <svg viewBox="0 0 40 90" fill="none">
                    <path
                      d="M20 88 C18 60 8 42 10 22 C12 8 20 2 20 2 C20 2 28 8 30 22 C32 42 22 60 20 88Z"
                      fill={`url(#${gid})`}
                      opacity="0.95"
                    />
                    <ellipse cx="20" cy="20" rx="7" ry="9" fill="#7b4bb7" />
                    <ellipse cx="20" cy="20" rx="4.2" ry="5.5" fill="#c2187a" />
                    <ellipse cx="20" cy="19" rx="2" ry="2.6" fill="#e8c547" />
                    <defs>
                      <linearGradient id={gid} x1="20" y1="2" x2="20" y2="88" gradientUnits="userSpaceOnUse">
                        <stop stopColor="#7b4bb7" />
                        <stop offset="0.45" stopColor="#c2187a" />
                        <stop offset="1" stopColor="#ff7e5f" />
                      </linearGradient>
                    </defs>
                  </svg>
                </motion.span>
              );
            })}
            <motion.div
              className="peacock-burst__heart"
              initial={{ scale: 0, opacity: 0 }}
              animate={{ scale: [0, 1.2, 1], opacity: 1 }}
              transition={{ delay: 0.15, duration: 0.45 }}
            >
              ♥
            </motion.div>
          </div>
          <motion.p
            initial={{ opacity: 0, y: 8 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2 }}
          >
            Added with a peacock sparkle
          </motion.p>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
